import { createMuiTheme } from '@material-ui/core';
import { fonts, schemes } from './tokens';

// Dedicated MUI v3 theme of the convention page. A nested MuiThemeProvider given an object theme REPLACES the
// outer theme (no merge): the global overrides of src/index.js (15px inputs, fixed heights) do not reach this page,
// and the back-office keeps its own theme untouched.
export const conventionPageTheme = (scheme) => {
    const colors = schemes[scheme] || schemes.light;
    return createMuiTheme({
        palette: {
            type: scheme === 'dark' ? 'dark' : 'light',
            primary: { main: colors.brand, dark: colors.brandHover, light: colors.focus, contrastText: colors.brandInk },
            background: { default: colors.bg, paper: colors.surface },
            text: { primary: colors.ink, secondary: colors.muted },
        },
        typography: { useNextVariants: true, fontFamily: fonts.sans },
        shape: { borderRadius: 8 },
        overrides: {
            MuiButton: {
                root: {
                    textTransform: 'none',
                    minHeight: 44,
                    minWidth: 44,
                    padding: '10px 18px',
                    borderRadius: 6,
                    fontSize: 15,
                    fontWeight: 600,
                    lineHeight: 1.3,
                },
                outlinedPrimary: { borderColor: colors.line, color: colors.ink },
            },
            MuiInputBase: {
                root: { minHeight: 44, fontFamily: fonts.mono },
                // >= 16px: no automatic zoom on iOS when the field gets the focus.
                input: { fontSize: 16, height: 'auto', padding: '10px 12px' },
            },
        },
    });
};

export default conventionPageTheme;
